import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import Tabs from '@boschebike/ebds-react/dist-esm/components/Tabs.js';

/**
 * @typedef {import('../../App.d.ts').ComponentLegalDocumentsProps} ComponentLegalDocumentsProps
 */
/**
 * @param {ComponentLegalDocumentsProps} props
 * @returns {Element}
 * @constructor
 */

export default ({ header, types, documents }) => {
  return (
    <Container>
      <h1>{header}</h1>
      <Tabs
        activeId={types[0].id}
        standout={false}
      >
        <Tabs.Navigation>
          {types.map((t) => (
            <Tabs.NavigationItem
              key={t.id}
              id={t.id}
            >
              {t.title}
            </Tabs.NavigationItem>
          ))}
        </Tabs.Navigation>
        <Tabs.Panels>
          {types.map((t) => (
            <Tabs.PanelItem
              key={t.id}
              id={t.id}
            >
              {documents
                .filter((d) => d.typeId === t.id)
                .map((d) => (
                  <div key={d.title}>
                    <h2>{d.title}</h2>
                    <div>
                      <a href={d.link}>{t.linkText}</a>
                    </div>
                    <div>
                      <a href={d.downloadLink}>{t.downloadLinkText}</a>
                    </div>
                  </div>
                ))}
            </Tabs.PanelItem>
          ))}
        </Tabs.Panels>
      </Tabs>
    </Container>
  );
};
